import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Atol9PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.ATOL9;
}

export default Atol9PoiTileEntity;
